<template>
  <div id="login" class="hold-transition login-page" @click="closeLangOption()">
    <div :class="[ app.pcDisp ? 'bg-img-pc' : 'bg-img-mobile ' + bgFilter ]">
      <div class="login-panel">
        <div class="login-header">
          <div class="company-logo">
            <img class="logo" src="../../assets/img/login/company-logo.png">
          </div>
        </div>

        <div class="login-body">
          <div class="body-left">
            <!-- <div class="main-content">TOG Mission</div>
            <div class="sub-content">To become a leading, sustainable, independent manufacturer with a global reputation for consistent service excellence, ease of doing business and supplying best value stock lenses and complete Rx service solutions on time every time. </div>
            
            <br>
            <div class="main-content">TOG Values</div>
            <div class="sub-content">We speak with one common voice.</div>
            <div class="sub-content">We are all accountable – we own and solve any customer issue;  we deliver on our promises.</div>
            <div class="sub-content">We strive to execute right first time, on time, every time.</div>
            <div class="sub-content">We are open and adaptable to change, try to keep things simple and operate with a "can-do" attitude. </div>
            <div class="sub-content">We are demanding on performance but equitable, remembering work should be enjoyable.</div> -->
          </div>
          <div class="body-right">
            <div class="box-login clearfix" v-show="loginDisp">
              <div class="box-title">{{ userBase }}</div>

              <div class="group-language">
                <div class="lang-display" @click.stop.prevent="toggleLangOption()">
                  <div class="lang-item">
                    <div class="lang-icon">
                      <img class="img-language" :src="require('static/images/flag_' + langFocus.icon + '_icon.png')">
                    </div>
                    <div class="lang-text">{{ langFocus.desc }}</div>
                    <div class="lang-icon-select"><i class="fa" :class="[ dispLangOption ? 'fa-chevron-up' : 'fa-chevron-down' ]"></i></div>
                  </div>
                </div>
                <div class="lang-option" v-show="dispLangOption">
                  <div v-for="(value, index) in app.allLang" :key="index"
                      @click="switchLang(value)"
                      class="lang-item"
                      :class="[ value === app.nowLang ? 'selected' : '' ]">
                    <div class="lang-icon">
                      <img class="img-language" :src="require('static/images/flag_' + value + '_icon.png')">
                    </div>
                    <div class="lang-text">{{ descLang[value] }}</div>
                  </div>
                </div>
              </div>

              <label class="box-input-material position-up clearfix">
                <div class="glyphicon glyphicon-user icon-id"></div>
                <input  class="upper" :class="{ 'focus' : username != '', 'input-error' : errors.has('username') }"
                        v-model="username"
                        @keyup.enter="$refs.passwordInput.focus()"
                        @keyup="clearResponse()"
                        name="username"
                        v-validate="'required'">
                <span>{{ labels[app.nowLang]['20'] }}</span>
                <div class="login-validate" v-show="errors.has('username')">{{ errors.first('username') }}</div>
              </label>

              <label class="box-input-material clearfix">
                <div class="fa fa-key icon-id"></div>
                <input  type="password"
                        ref="passwordInput"
                        :class="{ 'focus' : password != '', 'input-error' : errors.has('password') }"
                        v-model="password"
                        @keyup.enter="callSignIn()"
                        @keyup="clearResponse()"
                        name="password"
                        v-validate="'required'">
                <span>{{ labels[app.nowLang]['30'] }}</span>
                <div class="login-validate" v-show="errors.has('password')">{{ errors.first('password') }}</div>
              </label>

              <div class="infinite-loading-container" v-if="loadingDisp"><i class="loading-wave-dots"></i></div>
              <div class="response-msg" v-show="response !== ''">{{ response }}</div>

              <div class="link-forgot" @click="goForgotPassword()">{{ labels[app.nowLang]['50'] }} ?</div>
              <div class="link-change" @click="goChange()">{{ labels[app.nowLang]['60'] }}</div>

              <button class="btn-login submit" rel="go_item3" id="btn-login" v-on:click="callSignIn()">{{ labels[app.nowLang]['10'] }}</button>
            </div>
            <forgot-password  :forgotPasswordDisp="forgotPasswordDisp"
                              :forgotPasswordVerifyDisp="forgotPasswordVerifyDisp"
                              :pcDisp="app.pcDisp"
                              :goLogin="goLogin"
                              :inputUsername="inputUsername"
                              :loadingDisp="loadingDisp"
                              :postForgotPassword="postForgotPassword"
                              :postForgotPasswordVerify="postForgotPasswordVerify"
                              :response="response"
                              :setForgotPasswordResponse="setForgotPasswordResponse"
                              :labels="labels[app.nowLang]" />

            <change-password v-show="changePasswordDisp"
                             :pcDisp="app.pcDisp"
                             :goLogin="goLogin"
                             :inputUsername="inputUsername"
                             :postChangePassword="postChangePassword"
                             :changePasswordResponse="changePasswordResponse"
                             :setChangePasswordResponse="setChangePasswordResponse"
                             :flgAction="flgAction"
                             :formatPassword="formatPassword"
                             :setMsgFormatPassword="setMsgFormatPassword"
                             :labels="labels[app.nowLang]" />
          </div>
        </div>

        <div class="login-footer">
          <div class="software-name">
            <div class="header1">TOG Smart Life</div>
            <div class="build-time">ESS Version</div>
            <!-- <div class="build-time">Build time:</div> -->
          </div>
          <div class="software-logo">
            <img class="logo" src="~src/assets/img/login/logo_pps.png">
          </div>
          <div class="base-conn">{{ baseConn.user }}@{{ baseConn.db }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import * as types from 'store/modules/login/mutation-types'

import { EncodeUtils } from 'assets/encode'
import langLogin from 'components/login/langLogin'
import forgotPassword from 'components/login/forgotPassword'
import changePassword from 'components/login/changePassword'

export default {
  name: 'Login',
  data: function () {
    return {
      inputUsername: '',
      username: '',
      password: '',
      // changeDisp: false,
      isLoading: false,
      app: this.$parent,
      dispLangOption: false,
      descLang: {
        en: 'English',
        th: 'Thai'
      },
      langFocus: {
        icon: 'en',
        desc: 'English'
      }
    }
  },
  created () {
    this.receivedBaseConnection()
    let nowLang = this.app.nowLang
    this.langFocus = {
      icon: nowLang,
      desc: this.descLang[nowLang]
    }
  },
  components: {
    langLogin,
    forgotPassword,
    changePassword
  },
  computed: {
    userBase () {
      let user = this.labels[this.app.nowLang]['10']
      if (typeof this.baseConn.db !== 'undefined' && typeof this.baseConn.user !== 'undefined') {
        user = this.baseConn.db.indexOf('TRAIN') > -1 || this.baseConn.user.indexOf('TRAIN') > -1 ? this.labels[this.app.nowLang]['15'] : this.labels[this.app.nowLang]['10']
      }
      return user
    },
    bgFilter () {
      return this.forgotDisp || this.changePasswordDisp ? 'filter' : ''
    },
    formUser () {
      return {
        coduser: this.username,
        codpswd: (this.password !== '') ? EncodeUtils.stdenc(this.password) : '',
        codapp: this.$route.params.codapp
      }
    },
    // loadingDisp () {
    //   return this.isLoading && (this.response === '')
    // },
    ...mapGetters({
      loadingDisp: types.GET_LOGIN_LOADING_DISP,
      loginDisp: types.GET_LOGIN_LOGIN_DISP,
      forgotPasswordDisp: types.GET_LOGIN_FORGOT_PASSWORD_DISP,
      forgotPasswordVerifyDisp: types.GET_LOGIN_FORGOT_PASSWORD_VERIFY_DISP,
      changePasswordDisp: types.GET_LOGIN_CHANGE_PASSWORD_DISP,
      labels: types.GET_LOGIN_LABELS,
      currentUser: types.GET_CURRENT_USER,
      response: types.GET_RESPONSE,
      baseConn: types.GET_BASE_CONNECTION,
      forgotPasswordResponse: types.GET_FORGOT_PASSWORD_RESPONSE,
      changePasswordResponse: types.GET_CHANGE_PASSWORD_RESPONSE,
      flgAction: types.GET_LOGIN_FLG_ACTION,
      formatPassword: types.GET_LOGIN_FORMAT_PASSWORD
    })
  },
  watch: {
    'app.nowLang' () {
      this.langFocus = {
        icon: this.app.nowLang,
        desc: this.descLang[this.app.nowLang]
      }
    },
    username () {
      this.inputUsername = this.username
    }
  },
  methods: {
    clearResponse () {
      this.isLoading = false
      this.setResponse('')
    },
    callSignIn () {
      this.isLoading = false
      this.setResponse('')
      this.$validator.validateAll().then(result => {
        if (result) {
          this.isLoading = true
          this.postCurrentUser(this.formUser)
        }
      })
    },
    goForgotPassword () {
      this.toggleLoginPage('forgotPassword')
      this.inputUsername = this.username
      this.clearResponse()
      this.setFlgAction('forgot')
      this.errors.clear()
    },
    goForgotPasswordVerify () {
      this.toggleLoginPage('forgotPasswordVerify')
      this.inputUsername = this.username
      this.clearResponse()
      this.setFlgAction('forgot')
      this.errors.clear()
    },
    goChange () {
      this.toggleLoginPage('changePassword')
      this.inputUsername = this.username
      this.clearResponse()
      this.setFlgAction('change')
      this.errors.clear()
    },
    goLogin () {
      this.username = ''
      this.password = ''
      this.errors.clear()
      this.clearResponse()
      this.toggleLoginPage('login')
    },
    toggleLangOption () {
      this.dispLangOption = !this.dispLangOption
    },
    closeLangOption () {
      this.dispLangOption = false
    },
    switchLang (lang) {
      this.app.setLang(lang)
      this.langFocus = {
        icon: lang,
        desc: this.descLang[lang]
      }
      this.toggleLangOption()
    },
    ...mapMutations({
      setResponse: types.SET_RESPONSE,
      setForgotPasswordResponse: types.SET_FORGOT_PASSWORD_RESPONSE,
      setChangePasswordResponse: types.SET_CHANGE_PASSWORD_RESPONSE,
      setFlgAction: types.SET_LOGIN_FLG_ACTION,
      setMsgFormatPassword: types.SET_LOGIN_FORMAT_PASSWORD,
      toggleLoginPage: types.TOGGLE_LOGIN_PAGE
    }),
    ...mapActions({
      receivedBaseConnection: types.RECEIVED_BASE_CONNECTION,
      postCurrentUser: types.POST_CURRENT_USER,
      postForgotPassword: types.POST_FORGOT_PASSWORD,
      postForgotPasswordVerify: types.POST_FORGOT_PASSWORD_VERIFY,
      postChangePassword: types.POST_CHANGE_PASSWORD
    })
  }
}
</script>

<style src="./style.scss" lang="scss"></style>



// WEBPACK FOOTER //
// component.vue?decff490